
import { useDispatch, useSelector } from "react-redux"
import styled from "styled-components"
import {BsCheck2} from "react-icons/bs"
import { NumericFormat } from "react-number-format"
import InputText from "../../shared/input/new/InputText"
import { setSelectedGarageItem, updateGarageItem } from "../../../features/nakliyeHesaplama/nakliyeHesaplamaSlice"
import formatConverter from "../../../helper/formatConverter"

const Container = styled.div`
    width: calc(100% - 40px);
    height: calc(100%- 40px);
    margin: 20px;
    color: ${({theme}) => theme.mainTextColor};
    border: 1px solid ${({theme}) => theme.mainBorderColor};
    border-radius: 20px;

    .top-container{
        width: 100%;

        .h3{
            font-size: var(--font-size-md);
            font-weight: var(--font-weight-lg);
            color: var(--color-main);
            padding: 15px;
            border: 1px solid var(--color-main);
            display: inline-block;
            border-top-left-radius: 20px;
            border-bottom-right-radius: 20px;
        }
    }

    .garages-list{
        display: flex;
        flex-direction: column;
        padding: 10px;
    }

    table{
        margin-top: 10px;
        width: 100%;
        border-collapse: collapse;
        color: ${({theme}) => theme.mainTextColor};

        thead{
            width: 100%;

            tr{
                width: 100%;
                
                th{
                    padding: 6px 10px;
                    font-size: var(--font-size-sm);
                    font-weight: var(--font-weight-xl);
                    
                
                }
            }
        }

        tbody{
            width: 100%;
            

        }
    }
    
`


const GarageItem = styled.tr`
    width: 100%;
    padding: 6px 10px;
    font-size: var(--font-size-sm);
    font-weight: var(--font-weight-lg);
    text-align: center;

    td{
        padding: 13px 10px;
        font-size: var(--font-size-sm);
        font-weight: var(--font-weight-lg);
        text-align: center;

        &:nth-child(1){
            background-color: ${({theme}) => theme.mainBgColor} !important;
            width: 30px;
        }

        &:nth-child(2){
            border-radius: 10px 0 0 10px !important;
        }

        &:last-child{
            border-radius: 0 10px 10px 0 !important;
        }

        input{
            width: calc(100% - 40px);
            border-bottom: 1px solid ${({theme}) => theme.mainTextColor};
            text-align: center;
            padding-bottom: 5px;

            ::placeholder{
                text-align: center;
            }
        }

    }

    .checkbox{
        display: flex;
        justify-content: center;
        width: 30px;
        height: 30px;
        border-radius: 3px;
        display: flex;
        justify-content: center;
        align-items: center;
        background-color: ${({theme, selected}) => selected ? "var(--color-main)":  theme.mainBgColor};
        border: 1px solid ${({theme, selected}) => selected ? "transparent" : theme.transitionColor};
        cursor: pointer;
        
        .check-icon{
            font-size: 1.8rem;
            color: ${({theme, selected}) => selected ? "#fff" : theme.transitionColor};
        }
    }
`

const tableTitleList = ["Seç", "Dönüş Yeri", "Km", "Otoban-Köprü-Feribot Ücreti", "Hesaplanan Ek Yakıt Maliyeti", "Ek Maliyet Dahil Normal Gider Fiyatı"]

const ReturnGaragesList = () => {

    const {
        resReturnGaragesList,
        selectedGarageItem
    } = useSelector(state => state.nakliyeHesaplama)

    const dispatch = useDispatch()

    const handleChange = (e, item) => {
        

        dispatch(updateGarageItem({id: item.id, digerGiderler: e.target.value.replace(/[^0-9]/g, '')}))

    }


  return (
    <Container>

        <div className="top-container">
            <h3 className="h3">Geri Dönüş Yükü için Gidilebilecek En yakın Yerler</h3>
        </div>
        <div className="garages-list">
            <table>
                <thead>
                    <tr>
                        {
                            tableTitleList.map((item) => (
                                <th key={item}>{item}</th>
                            ))
                        }
                    </tr>
                </thead>
                <tbody>
                    {
                        resReturnGaragesList.map((item,i) => (
                            <GarageItem selected={selectedGarageItem?.id === item?.id} key={i}>
                                <td>
                                    <div className="check-container">
                                        <div className="checkbox" onClick={() => {dispatch(setSelectedGarageItem(selectedGarageItem?.id === item?.id ? null : item))}}>
                                            <BsCheck2 className="check-icon"/>
                                        </div>
                                    </div>
                                </td>
                                <td>{item.garageName}</td>
                                <td>{item.garageDistance}</td>
                                <td>
                                    <input type="text" value={item.digerGiderler} onChange={(e) => handleChange(e, item)} placeholder="Ücret Gir +"/>
                                </td>
                                <td>{formatConverter(item.yakitMaliyeti, 0)} TL</td>
                                <td>{formatConverter(item.middleMaliyetWithGarage, 0)} TL</td>
                            </GarageItem>
                        ))
                    }
                </tbody>
            </table>
        </div>

    </Container>
  )
}

export default ReturnGaragesList